import { STOREFRONT_COMPONENTS } from './components';
import type { StorefrontRenderingMode } from "../models/StorefrontResultsSettings";

// Shared merchant-facing names. Keep the API values stable when updating copy.
// The catalog order is also the order shown in the search-mode selector.
export const SEARCH_MODES = {
    AppProxyResults: {
        label: "PartFits results page",
        description: "Ready to use. No theme setup required.",
    },
    RenderedResults: {
        label: "Page in your theme",
        description: `Uses your existing page with the ${STOREFRONT_COMPONENTS.rendered_results.label} block.`,
    },
    CollectionFiltering: {
        label: "Shopify collection",
        description: "Filter a collection using your theme's product layout.",
    },
} as const satisfies Record<StorefrontRenderingMode, { label: string; description: string }>;

export const SEARCH_MODE_OPTIONS = Object.entries(SEARCH_MODES).map(([value, details]) => ({
    value: value as StorefrontRenderingMode,
    ...details,
}));

export const getSearchModeLabel = (mode: string | null | undefined): string =>
    SEARCH_MODE_OPTIONS.find(option => option.value === mode)?.label ?? "Unknown search mode";
